var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99808 1.71429C5.47273 1.71429 3.18629 2.67857 1.5055 4.24821C1.15268 4.57768 0.588709 4.56964 0.249772 4.22946C-0.0891639 3.88929 -0.0836075 3.34554 0.26922 3.01875C2.26672 1.14911 4.99488 0 7.99808 0C11.0013 0 13.7294 1.14911 15.7297 3.01875C16.0825 3.34821 16.0909 3.89196 15.7492 4.22946C15.4075 4.56696 14.8435 4.57768 14.4934 4.24821C12.8099 2.67857 10.5234 1.71429 7.99808 1.71429ZM6.66456 10.7143C6.66456 10.3733 6.80506 10.0463 7.05514 9.80515C7.30522 9.56403 7.64441 9.42857 7.99808 9.42857C8.35175 9.42857 8.69094 9.56403 8.94102 9.80515C9.1911 10.0463 9.3316 10.3733 9.3316 10.7143C9.3316 11.0553 9.1911 11.3823 8.94102 11.6234C8.69094 11.8645 8.35175 12 7.99808 12C7.64441 12 7.30522 11.8645 7.05514 11.6234C6.80506 11.3823 6.66456 11.0553 6.66456 10.7143ZM4.66428 7.88036C4.33923 8.23661 3.77804 8.26875 3.40855 7.95536C3.03905 7.64196 3.00571 7.10089 3.33076 6.74464C4.46981 5.50179 6.13949 4.71429 7.99808 4.71429C9.85667 4.71429 11.5264 5.50179 12.6654 6.74464C12.9904 7.10089 12.9543 7.64196 12.5876 7.95536C12.2209 8.26875 11.6569 8.23393 11.3319 7.88036C10.5151 6.98839 9.32604 6.42857 7.99808 6.42857C6.67012 6.42857 5.48106 6.98839 4.66428 7.88036Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompliance);
export default __webpack_public_path__ + "static/media/icon-compliance.8fc7aad1fa113fc1fa2c618dd0c19ae7.svg";
export { ForwardRef as ReactComponent };